/**
 * Owner: Masa Bayu
 * File: platform-access-principals.ts
 * Date:Time: 2026-09-23 15:52
 * Description: Capability assignment over existing QXRead accounts — no local IAM.
 */
import { assertNoForbiddenFoundationKey } from './authority';
export const QX_PLATFORM_CAPABILITIES = [
    'qxwriter',
    'qxread',
    'adam',
    'platform',
];
export const QX_PLATFORM_ACCESS_AUTHORITY_CHAIN = Object.freeze([
    'ExistingPlatformIdentity',
    'ExistingAuthorization',
    'FounderCapabilityAssignment',
    'ExistingQxWriterQxReadAdam',
]);
/** No module-local Founder account registry. */
export function qxPlatformLocalIdentityRegistry() {
    return Object.freeze([]);
}
export function projectAccountToCl3Actor(account) {
    assertNoForbiddenFoundationKey(account, 'QX Platform Access actor');
    return Object.freeze({
        accountId: account.accountId,
        roles: account.roles,
    });
}
export function findCapabilityAssignment(assignments, accountId) {
    const match = assignments.find((row) => row.accountId === accountId);
    if (match === undefined || match.authorityBypass !== false)
        return null;
    return match;
}
export function assignmentAllows(assignment, capability) {
    return assignment.capabilities.includes(capability);
}
//# sourceMappingURL=platform-access-principals.js.map